import { render, staticRenderFns } from "./MediakitProduct.vue?vue&type=template&id=c50831fe&"
import script from "./MediakitProduct.vue?vue&type=script&lang=js&"
export * from "./MediakitProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports